var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDiscounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4024_16426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66424 20H20C21.11 20 22 19.11 22 18V6C22 5.89382 21.9919 5.78965 21.9762 5.68809L20 7.66424V8H19.6642L15.6642 12H20V17C20 17.55 19.55 18 19 18H9.66424L7.66424 20Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12L18.25 8H15L11 12H14.25Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 18H8.25003L6.25003 20H4C3.7055 20 3.42648 19.9374 3.17547 19.8246L5 18Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58582 12H4V17C4 17.169 4.04249 17.3286 4.1173 17.4685L2.39194 19.1939C2.14539 18.8613 2 18.4486 2 18L2.01 6C2.01 4.89 2.89 4 4 4H17.5858L15.5858 6H4V8H13.5858L9.58582 12Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6H20V6.25003L21.5357 4.71431C21.1697 4.27685 20.6191 4 20 4H19L17 6Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 2.75L1.75 21.25H5L23.5 2.75H20.25Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4024_16426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDiscounts);
export default __webpack_public_path__ + "static/media/NoDiscounts.550a2fa4f4f9f9daf627f50184949d82.svg";
export { ForwardRef as ReactComponent };